import React from 'react';
import { Box, Typography, Grid, Link } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import NewsCard from '../../components/home/news-card';
import { useHomeState } from '../context/home-context';
import { useNavigate } from '../../../hooks/useNavigate';

export default function SectionNews() {
  const { topNews } = useHomeState();
  const navigate = useNavigate();

  if (!topNews || topNews.length === 0) {
    return null;
  }

  return (
    <Box component="section" id="news-section" sx={{ mb: 6 }}>
      <Typography
        variant="h2"
        component="h2"
        sx={{
          mb: 4,
          fontWeight: 700,
          color: 'primary.main',
          textAlign: 'left',
        }}
      >
        Últimas Notícias
      </Typography>

      <Grid container spacing={3}>
        {topNews.slice(0, 4).map((news, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <NewsCard news={news} />
          </Grid>
        ))}
      </Grid>

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <Link
          component="button"
          onClick={() => navigate('/noticias')}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            color: 'primary.main',
            textDecoration: 'none',
            fontSize: '1rem',
            fontWeight: 600,
            cursor: 'pointer',
            px: 3,
            py: 1.5,
            borderRadius: 1,
            border: '2px solid',
            borderColor: 'primary.main',
            transition: 'all 0.3s ease',
            '&:hover': {
              backgroundColor: 'primary.main',
              color: 'white',
              '& .arrow-icon': {
                transform: 'translateX(4px)',
              },
            },
          }}
        >
          Ver todas as notícias
          <ArrowForwardIcon
            className="arrow-icon"
            sx={{
              fontSize: '1.2rem',
              transition: 'transform 0.2s ease',
            }}
          />
        </Link>
      </Box>
    </Box>
  );
}
